import type { IHeaderParams } from 'ag-grid-community';

export interface SelectionHeaderParams extends IHeaderParams {
  onOpenFields: () => void;
  accessibleLabel: string;
  title: string;
}

/** The selection column's header slot: one button that opens the column chooser. */
export function SelectionHeader({ onOpenFields, accessibleLabel, title }: SelectionHeaderParams) {
  return (
    <button
      type="button"
      className="columns-header-button"
      aria-label={accessibleLabel}
      title={title}
      onClick={onOpenFields}
    >
      <svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false">
        <rect
          x="2.5"
          y="3.5"
          width="15"
          height="13"
          rx="1.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        ></rect>
        <path
          d="M7.5 3.5v13M12.5 3.5v13"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        ></path>
      </svg>
    </button>
  );
}
